import styled from 'styled-components';
import { ButtonTag } from "../Button/styles";
import { Dropdown } from "../../containers/DropdownContainer/styles";

export const ReviewsButtonContainer = styled.div`
  @media (min-width: 768px) {
    width: 100%;
    margin-bottom: 30px;
  }
  
  a {
    display: inline-block;
    width: 100%;
  }
  
  ${ButtonTag} {
    width: 100%;
    padding: 5px 30px;

    font-size: 12px;

    @media(min-width: 768px) {
      padding: 20px 30px;
  
      font-size: 16px;
    }
  }
`;

export const ReviewsDropdown = styled.div`
  height: 200px;
  margin-bottom: 10px;
  overflow-y: scroll;
  
  @media(min-width: 768px) {
    height: 400px;
  }
  
  @media(max-height: 800px) and (min-width: 768px) {
    height: 300px;
  }
  
  @media(max-height: 700px) and (min-width: 768px) {
    height: 200px;
  }
`;

export const ReviewsInfo = styled.div`
  display: flex;
  justify-content: center;

  @media(min-width: 768px) {
    width: 100%;
    justify-content: flex-start;
    margin-bottom: 25px;
  }
`;

export const ReviewsPanelFooter = styled.footer`
  display: none;
  
  @media (min-width: 768px) {
    display: flex;
    align-items: center;
    width: 100%;
    padding-top: 25px;
  
    border-top: 1px solid ${({ theme }) => theme.lightGray};
  }

  svg {
    margin-right: 25px;
    flex-shrink: 0;

    stroke: ${({ theme }) => theme.blue};
    fill: none;
  }
`;

export const ReviewsPanelWays = styled.span`
  display: block;
  width: 100%;
  padding: 15px 35px;

  font-size: 16px;
  color: ${({ theme }) => theme.black};

  transition: background-color 0.3s;
  cursor: pointer;
  
  a {
    color: inherit;
  }

  &:hover {
    background-color: #f8f8f8;
  }
`;

export const ReviewsPanelFeature = styled.button`
  position: relative;

  width: 100%;
  padding: 20px;

  text-align: left;
  
  border: 1px solid #ebebeb;
  border-radius: 6px;

  cursor: pointer;

  h3 {
    margin: 0;
    margin-bottom: 10px;
    padding: 0;

    font-weight: 400;
    font-size: 14px;
    line-height: 1;
    color: #8d8d8d;
  }

  .panel-container {
    display: flex;
    align-items: center;
    justify-content: space-between;

    font-weight: 700;

    svg {
      flex-shrink: 0;
    }
  }
`;

export const ReviewsPanelFeatureWrapper = styled.div`
  position: relative;
  width: 100%;
  margin-top: 15px;
  
  ${Dropdown} {
    min-width: auto;
    width: 100%;
  }
  
  @media (min-width: 768px) {
    display: none;
    margin-top: 0;
    margin-bottom: 25px;
  }
`;

export const ReviewsPhoto = styled.div`
  width: 56px;
  height: 56px;
  flex-shrink: 0;
  margin-right: 10px;

  border-radius: 6px;
  overflow: hidden;

  @media(min-width: 768px) {
    width: 80px;
    height: 80px;
    margin-right: 15px;
  }

  img {
    width: 100%;
    height: 100%;

    object-fit: cover;
  }
`;

export const ReviewsPanelDescription = styled.p`
  margin: 0;
  padding: 0;

  font-size: 14px;
  line-height: 16px;
`;

export const ReviewsPanelStats = styled.div`
  display: flex;
  align-items: center;
`;

export const ReviewsPanelVotes = styled.span`
  margin-left: 5px;

  font-size: 14px;
  line-height: 1;
  color: ${({ theme }) => theme.blue};
`;

export const ReviewsInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ReviewsFeaturesList = styled.ul`
  display: flex;
  flex-wrap: wrap;

  li {
    font-size: 10px;
    line-height: 1;

    &:not(:last-child) {
      position: relative;

      &::after {
        content: "";

        display: inline-block;
        vertical-align: middle;
        margin: 0 10px;
        width: 4px;
        height: 4px;

        background-color: #9a9a9a;
        border-radius: 50%;
      }
    }
    
    @media (min-width: 768px) {
      font-size: 12px;
    }
  }
`;

export const HotelName = styled.p`
  margin: auto 0;
  padding: 0;

  font-weight: 700;
  font-size: 14px;
  line-height: 14px;

  @media(min-width: 768px) {
    font-size: 16px;
    line-height: 16px;
  }
`;

export const ReviewsPanelContainer = styled.article`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 25px;
  
  ${ReviewsPanelFeatureWrapper} {
    display: none;
  }

  @media (min-width: 768px) {
    flex-direction: column;
    padding: 0;
  
    ${ReviewsPanelFeatureWrapper} {
      display: flex;
    }
  }
`;
